import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Validators, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material';

// -----------------------------------------------------------------
// SERVICES/SERVICIOS
// -----------------------------------------------------------------
import { ValidatorService } from '../../services/validators/validator.service';
import * as DATA from '../../models/staticdata';
// -----------------------------------------------------------------
// COMPONENTS/COMPONENTES
// -----------------------------------------------------------------
import { AlertComponent } from '../../components/alert/alert.component';
import { RegistrationService } from '../../services/registration/registration.service';
import { Concept } from '../../models/concept.model';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { ConceptValues } from '../../models/concept-values.model';
import { GeneralService } from '../../services/general/general.service';
import { Router } from '@angular/router';
import { InputTextComponent } from '@asambleas-components/input-text/input-text.component';

@Component({
    selector: 'app-register-2',
    templateUrl: './register-2.component.html',
    styleUrls: ['./register-2.component.scss']
})
export class Register2Component implements OnInit {

    // -----------------------------------------------------------------
    // ATTRIBUTES/ATRIBUTOS
    // -----------------------------------------------------------------
    secondFormGroup: FormGroup;
    @Output() FormEvent2 = new EventEmitter<any>();

    // Date Piker Validation
    actualDate = new Date();
    actualYear = this.actualDate.getFullYear();
    minBornDate = new Date(1918, 0, 1);
    maxBornDate = new Date((this.actualYear - 18), 11, 31);

    startDate = new Date(1944, 0, 1);

    //Data to fill Select
    genderValues: ConceptValues;
    documentValues: ConceptValues;
    maritalStatusValues: ConceptValues;
    cityValues: any;
    streetValues: ConceptValues;

    filteredBornCities: Observable<ConceptValues[]>;
    filteredResidenceCities: Observable<ConceptValues[]>;

    inputsNamesValidation;

    // -----------------------------------------------------------------
    // CONSTRUCTOR
    // -----------------------------------------------------------------
    constructor(
        private fb: FormBuilder,
        private dialog: MatDialog,
        private customValidators: ValidatorService,
        private generalService: GeneralService,
        private registrationService: RegistrationService,
        private _router: Router
    ) {

        this.secondFormGroup = new FormGroup({
            ctrlGender: new FormControl({ value: '', disabled: false }, [Validators.required, customValidators.validAutocomplete]),
            ctrlFirstName: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.minLength(3)]),
            ctrlMiddleName: new FormControl({ value: '', disabled: false }),
            ctrlLastName: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.minLength(3)]),
            ctrlSecondLastName: new FormControl({ value: '', disabled: false }),
            ctrlDocumentType: new FormControl({ value: '', disabled: false }, [Validators.required, customValidators.validAutocomplete]),
            ctrlNumberDocument: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.min(1000000)]),
            ctrlBirthDate: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.minLength(8)]),
            ctrlBornCity: new FormControl({ value: '', disabled: false, autocomplete: 'thisIsAnInvalidValue' }, [Validators.required]),
            ctrlMaritalStatus: new FormControl({ value: '', disabled: false }, Validators.required),
            ctrlResidenceCity: new FormControl({ value: '', disabled: false }, [Validators.required]),
            ctrlStreetType: new FormControl({ value: '', disabled: false }, [Validators.required, customValidators.validAutocomplete]),
            ctrlStreetName: new FormControl({ value: '', disabled: false }, Validators.required),
            ctrlAddress1: new FormControl({ value: '', disabled: false }, Validators.required),
            ctrlAddress2: new FormControl({ value: '', disabled: false }, Validators.required),
            ctrlEmail: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.email, customValidators.validateEmail]),
            ctrlPassword: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.minLength(8)])
        });

        this.inputsNamesValidation = {
            ctrlGender: 'Género',
            ctrlFirstName: 'Primer Nombre',
            ctrlMiddleName: 'Segundo nombre',
            ctrlLastName: 'Primer Apellido',
            ctrlSecondLastName: 'Segundo apellido',
            ctrlDocumentType: 'Tipo de documento',
            ctrlNumberDocument: 'Número de documento',
            ctrlBirthDate: 'Fecha de nacimiento',
            ctrlBornCity: 'Ciudad de nacimiento',
            ctrlMaritalStatus: 'Estado civil',
            ctrlResidenceCity: 'Ciudad de residencia',
            ctrlStreetType: 'Dirección',
            ctrlStreetName: 'Nombre de Calle',
            ctrlAddress1: 'Número',
            ctrlAddress2: 'Casa',
            ctrlEmail: 'Correo electrónico',
            ctrlPassword: 'Contraseña'
        }
    }

    ngOnInit() {
        this.documentValues = this.generalService.concepts[1]
        if (this.documentValues == null) {
            this.generalService.getConceptDataById(1).subscribe((data: Concept) => {
                this.documentValues = data.values
            })
        }

        this.maritalStatusValues = this.generalService.concepts[2]
        if (this.maritalStatusValues == null) {
            this.generalService.getConceptDataById(2).subscribe((data: Concept) => {
                this.maritalStatusValues = data.values
            })
        }

        this.genderValues = this.generalService.concepts[3]
        if (this.genderValues == null) {
            this.generalService.getConceptDataById(3).subscribe((data: Concept) => {
                this.genderValues = data.values
            })
        }

        this.cityValues = this.generalService.concepts[6]
        if (this.cityValues == null) {
            this.generalService.getConceptDataById(6).subscribe((data: Concept) => {
                this.cityValues = data.values
            })
        }

        this.streetValues = this.generalService.concepts[9]
        if (this.streetValues == null) {
            this.generalService.getConceptDataById(9).subscribe((data: Concept) => {
                this.streetValues = data.values
            })
        }

        this.setBornCityFilterOptions()
        this.setResidenceCityFilterOptions()
    }

    setBornCityFilterOptions() {
        this.filteredBornCities = this.secondFormGroup.get('ctrlBornCity').valueChanges.pipe(
            startWith(''),
            map(val => this.filterBornCity(val))
        );
    }

    displayFnBornCity(cities?: ConceptValues): string | undefined {
        return cities ? cities.description : undefined;
    }

    filterBornCity(opt: any): ConceptValues[] {
        if (typeof (opt) == "string") {
            return this.cityValues.filter(option => option.description.toLowerCase().indexOf(opt.toLowerCase()) !== -1);
        } else if (typeof (opt) == "object") {
            return this.cityValues.filter(option => option.description.toLowerCase().indexOf(opt.description.toLowerCase()) !== -1);
        } else {
            return this.cityValues;
        }
    }

    setResidenceCityFilterOptions() {
        this.filteredResidenceCities = this.secondFormGroup.get('ctrlResidenceCity').valueChanges.pipe(
            startWith(''),
            map(val => this.filterResidenceCity(val))
        );
    }

    displayFnResidenceCity(cities?: ConceptValues): string | undefined {
        return cities ? cities.description : undefined;
    }

    filterResidenceCity(opt: any): ConceptValues[] {
        if (typeof (opt) == "string") {
            return this.cityValues.filter(option => option.description.toLowerCase().indexOf(opt.toLowerCase()) !== -1);
        } else if (typeof (opt) == "object") {
            return this.cityValues.filter(option => option.description.toLowerCase().indexOf(opt.description.toLowerCase()) !== -1);
        } else {
            return this.cityValues;
        }
    }

    changeBornDatePicker(bornDateValue) {
        console.log('bornDateValue=', bornDateValue)

        let date = new Date(bornDateValue).toISOString();
        console.log('date=', date)
        return date
    }

    onSave($event) {
        console.log(this.secondFormGroup);

        //return;

        if (this.secondFormGroup.valid) {
            this.FormEvent2.emit(this.secondFormGroup.value)
        } else {

            let message = '';
            //console.log(this.secondFormGroup.controls);

            let fields = this.secondFormGroup.controls

            for (let field in fields) {
                //console.log(fields[field]);

                if (fields[field].invalid) {
                    //console.log(`El campo ${this.inputsNamesValidation[field]} es inválido`);
                    message = message.concat(`El campo ${this.inputsNamesValidation[field]} es inválido <br />`);
                }
            }

            console.log(this.secondFormGroup.getError($event))
            this.dialog.open(AlertComponent, {
                width: '35vw',
                disableClose: true,
                data: {
                    title: 'Atención',
                    content: "Formulario inválido, verifique los datos ingresados. <br /> <span class='text-red'>" + message + "</span>"
                }
            })
        }
    }

    cancel() {
        this._router.navigate(['/'])
    }

    addCity(formControl: string) {
        const ref = this.dialog.open(InputTextComponent, { data: { title: 'Ingrese su ciudad', placeholder: 'Nombre' } });

        ref.afterClosed()
            .subscribe((data) => {
                if (data) {

                    this.secondFormGroup.controls[formControl].patchValue({ value: data, description: data });
                }
            })
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/register-2/register-2.component.ts